import { WarningIcon } from "@phosphor-icons/react/dist/csr/Warning";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { cn } from "@volca/ui/lib/utils";
import type { ApAgentAction } from "@/accounts-payable/types";

/**
 * What changed in ServiceTitan since the action was proposed, as of its last
 * re-check: "Cost of S3033-NS was $199.00 when proposed; ServiceTitan now has
 * $214.65." Under the action's title wherever it can be approved, so the
 * reviewer reads it before approving against the current values. Renders
 * nothing when nothing changed.
 */
export const StChangesNote = ({
  action,
  className,
}: {
  action: ApAgentAction;
  className?: string;
}) => {
  const changes = action.st_changes ?? [];
  if (changes.length === 0) return null;

  return (
    <Stack align="start" gap={0} className={cn("mt-0.5 w-full", className)}>
      {changes.map((change) => (
        <Stack
          key={change}
          direction="row"
          gap={1}
          align="start"
          className="text-warning"
        >
          <WarningIcon className="mt-0.5 size-3 flex-none" aria-hidden />
          <Text variant="caption">{change}</Text>
        </Stack>
      ))}
    </Stack>
  );
};
